//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"ErrorCode",1,1]],[[["solidTag"],"GetParasolidId",{R_:{parasolidId:''}},1,0],[["parasolidId"],"GetNXObject",{R_:{solidTag:"DisplayableObject"}},1,0],[["numConstructionFeaturesTags"],"GetConstructionFeatures",{R_:{constructionFeaturesTags:"Features.ConstructionFeatureData[]"}},0,0],[["numOutputFeatureData"],"GetOutputFeatures",{R_:{outputFeatureData:"Features.OutputFeatureData[]"}},0,0],[[],"GetCustomFeature",{R_:{cfFrec:"Features.CustomFeature"}},0,0]],[]];
SPLM.Features.CustomFeatureEvent = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CustomFeatureEvent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;